<template>
  <WdsStack direction-row justify-space-between gap-md>
    <slot />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack } from '@worksome/wds-components'
</script>
